import { Theme, css } from '@emotion/react';

// It's unsatisfying that we're hard-coding the heights of the headers
// that appear in the search results, subtracting them out from the height of search
// interface components.

const desktopHeaderHeight = '84px';
const mobileHeaderHeight = '68px';

export const desktopSearchBarHeight = '81px';
export const mobileSearchBarHeight = '71px';

export const availabilitySearchResultsHeight = (
  { breakpoints }: Theme,
  allowSpaceForSearchBar: boolean
) => {
  let desktopPixelSubtractions = `- ${desktopHeaderHeight}`;
  let mobilePixelSubtractions = `- ${mobileHeaderHeight} - env(safe-area-inset-bottom) - env(safe-area-inset-top)`;

  if (allowSpaceForSearchBar) {
    desktopPixelSubtractions += ` - ${desktopSearchBarHeight}`;
    mobilePixelSubtractions += ` - ${mobileSearchBarHeight}`;
  }

  return css`
    height: calc(100vh ${mobilePixelSubtractions});
    ${breakpoints.up('sm')} {
      height: calc(100vh ${desktopPixelSubtractions});
    }
  `;
};
